import FormCard from '../../../inputFormComponents/FormCard'
import { FormDataConsumer, TextInput, email, required, useTranslate } from 'react-admin'
import FormRow from '../../../inputFormComponents/FormRow'
import CustomerInput from '../CustomerInput'
import { InvoiceType } from '../../../GeneratedClients/FreeBillApi'
import { postCode } from '../../../validators/validate'

interface IProps {
  cardNumber?: number
  description?: JSX.Element
  invoiceType: InvoiceType
}

const InvoiceAdressCard = ({cardNumber, description, invoiceType}: IProps) => {

  const translate = useTranslate()
  
  const validateUstId = () => {
    var validators = []
    if(invoiceType === InvoiceType.EuInvoiceDelivery || invoiceType === InvoiceType.EuInvoiceService) {
      validators.push(required("Pflichtfeld für eine EU Rechnung"))
    }
    return validators
  }

  return (
    <FormCard 
      title={translate('resources.invoices.form.invoiceAdress')}
      cardNumber={cardNumber}
      description={description}
      rows={[
        <FormRow fields={[
          <CustomerInput /> 
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="invoiceRecipient.company.additionalAddress" label="resources.company.additionalAddress" />,
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="invoiceRecipient.company.street" label="resources.company.street" validate={required()} />,
        ]} />,
        <FormRow fields={[
          <FormDataConsumer>
            {({formData, ...rest}) => 
              <TextInput 
                fullWidth 
                helperText={false} 
                source="invoiceRecipient.company.postCode" 
                label="resources.company.postCode" 
                validate={
                  !formData.invoiceRecipient?.company?.country
                  || formData.invoiceRecipient?.company?.country === "" 
                  || formData.invoiceRecipient?.company?.country === "Deutschland" 
                  || formData.invoiceRecipient?.company?.country === "Germany" 
                  ? [required(), postCode()] 
                  : undefined
                } 
              
              />    
            }
          </FormDataConsumer>,
          <TextInput fullWidth helperText={false} source="invoiceRecipient.company.city" sx={{ml:2}} label="resources.company.city" validate={required()} />,
          <TextInput fullWidth helperText={false} source="invoiceRecipient.company.country" sx={{ml:2}} label="resources.company.country" />
        ]} />,
        <FormRow fields={[
          <TextInput fullWidth helperText={false} source="invoiceRecipient.company.email" label="resources.company.email" validate={email()} />,
          <TextInput 
            fullWidth 
            helperText={false} 
            source="invoiceRecipient.ustId" 
            sx={{ml:2}} 
            label="resources.customers.ustId" 
            validate={validateUstId()}
          />
        ]} />
      ]}
    />
  )
}

export default InvoiceAdressCard